import { isTriggerOrderType } from '@/constants/advancedOrder';
import { matchaFees } from '@/constants/matchaFees';

import type { LimitOrderItem } from '@/utils/0x.types';

/**
 * Flash platform fee deducted from output on every Definitive order.
 * Documented promotional rate through December 2026:
 * https://flash.definitive.fi/docs/monetizing-your-integration.md
 */
export const DEFINITIVE_PLATFORM_FEE_BPS = 10;

export const ADVANCED_ESTIMATED_FEES_LABEL = 'Estimated fees';
export const ADVANCED_TRIGGER_RECEIVE_LABEL = 'Est. at trigger (after fees)';

export function getLimitOrderIntegratorFeeBps(isStableToStablePair: boolean): number {
  return isStableToStablePair ? matchaFees.limitOrder.stables : matchaFees.limitOrder.default;
}

/**
 * The Buy amount to show for an open order: Definitive's net-of-fees estimate
 * when it was recorded at placement, otherwise the gross limit terms (which
 * `takerAmount` always holds, since the price column derives from it).
 */
export function getLimitOrderDisplayBuyAmount(item: LimitOrderItem): {
  amount: string;
  isApproximate: boolean;
} {
  if (item.provider === 'definitive' && item.estimatedTakerAmount) {
    return { amount: item.estimatedTakerAmount, isApproximate: true };
  }
  return { amount: item.takerAmount, isApproximate: isTriggerOrderType(item.advancedOrderType) };
}
